var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Admin',[_c('v-main',[_c('div',{staticClass:"tw-px-5"},[_c('Table')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }